<template>
    <ul class="menu-list">
      <li class="menu-list__item">
        <div class="menu-list__button" :class="notificationWidgetActive ? 'active notification-btn' : ''" @click.stop="toggleNotificationWidget">
          <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_notification" fill="currentColor">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.3802 9.03382C4.75541 5.50904 8.24706 2.74707 12.499 2.74707C16.7476 2.74707 20.2371 5.50475 20.6169 9.02561C21.0436 10.2298 21.0786 11.3905 21.1134 12.5482C21.1645 14.2454 21.2153 15.936 22.5 17.7474C24.6151 20.7297 25 23.4982 25 23.4982H0C0 23.4982 0.384876 20.7297 2.5 17.7474C3.78466 15.936 3.83553 14.2454 3.8866 12.5483C3.92136 11.3932 3.9562 10.235 4.3802 9.03382Z"/>
            </mask>
            <path d="M4.3802 9.03382L5.79467 9.53309L5.85317 9.36736L5.87177 9.1926L4.3802 9.03382ZM20.6169 9.02561L19.1255 9.18647L19.1444 9.3611L19.2031 9.52666L20.6169 9.02561ZM21.1134 12.5482L19.6141 12.5934L21.1134 12.5482ZM22.5 17.7474L21.2765 18.6151L22.5 17.7474ZM25 23.4982V24.9982H26.723L26.4857 23.2917L25 23.4982ZM0 23.4982L-1.48571 23.2917L-1.72295 24.9982H0V23.4982ZM2.5 17.7474L3.72352 18.6151L2.5 17.7474ZM3.8866 12.5483L2.38728 12.5031L3.8866 12.5483ZM5.87177 9.1926C6.14657 6.6111 8.81758 4.24707 12.499 4.24707V1.24707C7.67653 1.24707 3.36426 4.40698 2.88862 8.87504L5.87177 9.1926ZM12.499 4.24707C16.1773 4.24707 18.8474 6.60745 19.1255 9.18647L22.1082 8.86475C21.6269 4.40204 17.3179 1.24707 12.499 1.24707V4.24707ZM19.2031 9.52666C19.5403 10.4782 19.5785 11.4111 19.6141 12.5934L22.6127 12.5031C22.5786 11.37 22.547 9.98137 22.0307 8.52456L19.2031 9.52666ZM19.6141 12.5934C19.6652 14.2926 19.7065 16.4015 21.2765 18.6151L23.7235 16.8796C22.7242 15.4705 22.6637 14.1982 22.6127 12.5031L19.6141 12.5934ZM21.2765 18.6151C22.2332 19.9641 22.7982 21.2647 23.1224 22.2223C23.2842 22.7 23.3847 23.0884 23.4437 23.3494C23.4731 23.4798 23.492 23.5779 23.503 23.6388C23.5085 23.6693 23.5119 23.6904 23.5137 23.7016C23.5146 23.7072 23.5151 23.7103 23.5152 23.7109C23.5152 23.7112 23.5151 23.7108 23.515 23.7098C23.5149 23.7093 23.5148 23.7086 23.5147 23.7078C23.5146 23.7073 23.5146 23.7069 23.5145 23.7064C23.5145 23.7061 23.5144 23.7057 23.5144 23.7056C23.5143 23.7052 23.5143 23.7048 25 23.4982C26.4857 23.2917 26.4856 23.2912 26.4856 23.2908C26.4856 23.2906 26.4855 23.2901 26.4855 23.2898C26.4854 23.2891 26.4853 23.2884 26.4851 23.2877C26.4849 23.2862 26.4847 23.2845 26.4844 23.2826C26.4839 23.2789 26.4833 23.2745 26.4825 23.2695C26.481 23.2594 26.479 23.2466 26.4766 23.2312C26.4717 23.2004 26.4648 23.1591 26.4557 23.1081C26.4373 23.006 26.4097 22.8644 26.37 22.6886C26.2906 22.3373 26.1628 21.8473 25.9639 21.2601C25.5669 20.0877 24.882 18.513 23.7235 16.8796L21.2765 18.6151ZM25 21.9982H0V24.9982H25V21.9982ZM0 23.4982C1.48571 23.7048 1.48565 23.7052 1.48559 23.7056C1.48558 23.7057 1.48552 23.7061 1.48549 23.7064C1.48542 23.7069 1.48535 23.7073 1.48529 23.7078C1.48517 23.7086 1.48508 23.7093 1.485 23.7098C1.48486 23.7108 1.4848 23.7112 1.48484 23.7109C1.48492 23.7103 1.48539 23.7072 1.48628 23.7016C1.48806 23.6904 1.49153 23.6693 1.49701 23.6388C1.50796 23.5779 1.52691 23.4798 1.55635 23.3494C1.61528 23.0884 1.71583 22.7 1.87758 22.2223C2.20182 21.2647 2.76683 19.9641 3.72352 18.6151L1.27648 16.8796C0.118049 18.513 -0.566947 20.0877 -0.963925 21.2601C-1.16278 21.8473 -1.29065 22.3373 -1.36998 22.6886C-1.40967 22.8644 -1.43732 23.006 -1.45567 23.1081C-1.46485 23.1591 -1.47171 23.2004 -1.4766 23.2312C-1.47905 23.2466 -1.481 23.2594 -1.48251 23.2695C-1.48326 23.2745 -1.4839 23.2789 -1.48443 23.2826C-1.4847 23.2845 -1.48494 23.2862 -1.48515 23.2877C-1.48526 23.2884 -1.48536 23.2891 -1.48545 23.2898C-1.4855 23.2901 -1.48556 23.2906 -1.48559 23.2908C-1.48565 23.2912 -1.48571 23.2917 0 23.4982ZM3.72352 18.6151C5.29347 16.4015 5.33479 14.2926 5.38592 12.5934L2.38728 12.5031C2.33627 14.1982 2.27585 15.4705 1.27648 16.8796L3.72352 18.6151ZM5.38592 12.5934C5.42142 11.4137 5.45954 10.4826 5.79467 9.53309L2.96572 8.53456C2.45287 9.98754 2.4213 11.3726 2.38728 12.5031L5.38592 12.5934Z" fill="currentColor" mask="url(#path-1-inside-1_notification)"/>
            <mask id="path-3-inside-2_notification" fill="currentColor">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.78092 22.7285C7.72414 23.0082 7.69434 23.2976 7.69434 23.594C7.69434 25.9837 9.63157 27.921 12.0213 27.921C14.411 27.921 16.3482 25.9837 16.3482 23.594C16.3482 23.2976 16.3184 23.0082 16.2616 22.7285H14.7132C14.8009 23.0013 14.8482 23.2921 14.8482 23.594C14.8482 25.1553 13.5825 26.421 12.0213 26.421C10.46 26.421 9.19434 25.1553 9.19434 23.594C9.19434 23.2921 9.24166 23.0013 9.3293 22.7285H7.78092Z"/>
            </mask>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.78092 22.7285C7.72414 23.0082 7.69434 23.2976 7.69434 23.594C7.69434 25.9837 9.63157 27.921 12.0213 27.921C14.411 27.921 16.3482 25.9837 16.3482 23.594C16.3482 23.2976 16.3184 23.0082 16.2616 22.7285H14.7132C14.8009 23.0013 14.8482 23.2921 14.8482 23.594C14.8482 25.1553 13.5825 26.421 12.0213 26.421C10.46 26.421 9.19434 25.1553 9.19434 23.594C9.19434 23.2921 9.24166 23.0013 9.3293 22.7285H7.78092Z" fill="none"/>
            <path d="M7.78092 22.7285V21.2285H6.55485L6.31091 22.4301L7.78092 22.7285ZM16.2616 22.7285L17.7316 22.4301L17.4877 21.2285H16.2616V22.7285ZM14.7132 22.7285V21.2285H12.6558L13.2851 23.1873L14.7132 22.7285ZM9.3293 22.7285L10.7574 23.1873L11.3867 21.2285H9.3293V22.7285ZM6.31091 22.4301C6.2343 22.8074 6.19434 23.1968 6.19434 23.594H9.19434C9.19434 23.3984 9.21398 23.2089 9.25093 23.027L6.31091 22.4301ZM6.19434 23.594C6.19434 26.8122 8.80314 29.421 12.0213 29.421V26.421C10.46 26.421 9.19434 25.1553 9.19434 23.594H6.19434ZM12.0213 29.421C15.2394 29.421 17.8482 26.8122 17.8482 23.594H14.8482C14.8482 25.1553 13.5825 26.421 12.0213 26.421V29.421ZM17.8482 23.594C17.8482 23.1968 17.8082 22.8074 17.7316 22.4301L14.7916 23.027C14.8285 23.2089 14.8482 23.3984 14.8482 23.594H17.8482ZM16.2616 21.2285H14.7132V24.2285H16.2616V21.2285ZM16.3482 23.594C16.3482 23.1345 16.276 22.689 16.1413 22.2697L13.2851 23.1873C13.3257 23.3136 13.3482 23.4497 13.3482 23.594H16.3482ZM12.0213 27.921C14.411 27.921 16.3482 25.9837 16.3482 23.594H13.3482C13.3482 24.3269 12.7541 24.921 12.0213 24.921V27.921ZM7.69434 23.594C7.69434 25.9837 9.63157 27.921 12.0213 27.921V24.921C11.2884 24.921 10.6943 24.3269 10.6943 23.594H7.69434ZM7.90119 22.2697C7.76649 22.689 7.69434 23.1345 7.69434 23.594H10.6943C10.6943 23.4497 10.7168 23.3136 10.7574 23.1873L7.90119 22.2697ZM9.3293 21.2285H7.78092V24.2285H9.3293V21.2285Z" fill="currentColor" mask="url(#path-3-inside-2_notification)"/>
            <circle cx="12.5006" cy="1.78571" r="1.78571" fill="currentColor"/>
          </svg>
          <div class="menu-list__link__counter" v-if="notificationCounter">
            {{ notificationCounter }}
          </div>
        </div>
      </li>
      <li class="menu-list__item" v-if="roleAccessDialogs">
        <div class="menu-list__button" :class="dialogWidgetActive ? 'active dialog-btn' : ''" @click.stop="toggleDialogWidget">
          <svg width="35" height="31" viewBox="0 0 35 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30.9874 24.1689L30.3195 23.8279L30.1595 24.1411L30.2981 24.4643L30.9874 24.1689ZM27.8258 27.8181L28.063 27.1066L27.7027 26.9865L27.3927 27.2058L27.8258 27.8181ZM33.339 29.6559L33.1018 30.3674L34.6863 30.8955L34.0284 29.3604L33.339 29.6559ZM31.3315 19.6028C31.3315 21.1255 30.9664 22.5608 30.3195 23.8279L31.6554 24.5099C32.4076 23.0366 32.8315 21.3681 32.8315 19.6028H31.3315ZM22.0261 10.2974C27.1654 10.2974 31.3315 14.4635 31.3315 19.6028H32.8315C32.8315 13.6351 27.9938 8.79736 22.0261 8.79736V10.2974ZM12.7207 19.6028C12.7207 14.4635 16.8869 10.2974 22.0261 10.2974V8.79736C16.0585 8.79736 11.2207 13.6351 11.2207 19.6028H12.7207ZM22.0261 28.9082C16.8869 28.9082 12.7207 24.742 12.7207 19.6028H11.2207C11.2207 25.5705 16.0585 30.4082 22.0261 30.4082V28.9082ZM27.3927 27.2058C25.8764 28.2782 24.026 28.9082 22.0261 28.9082V30.4082C24.3462 30.4082 26.4976 29.6761 28.2589 28.4305L27.3927 27.2058ZM27.5886 28.5296L33.1018 30.3674L33.5762 28.9443L28.063 27.1066L27.5886 28.5296ZM34.0284 29.3604L31.6768 23.8734L30.2981 24.4643L32.6496 29.9513L34.0284 29.3604Z" fill="currentColor"/>
            <path d="M3.54701 9.30178L4.17401 8.89023L4.41088 9.2511L4.21783 9.63719L3.54701 9.30178ZM5.895 11.2823L5.68896 10.5612L5.94766 10.4873L6.19436 10.5947L5.895 11.2823ZM2.00035 12.3951L2.2064 13.1162L0.567068 13.5846L1.32953 12.0597L2.00035 12.3951ZM3.42075 6.36286C3.42075 7.29727 3.69779 8.16469 4.17401 8.89023L2.92001 9.71332C2.28821 8.75076 1.92075 7.59858 1.92075 6.36286H3.42075ZM8.03362 1.75C5.486 1.75 3.42075 3.81525 3.42075 6.36286H1.92075C1.92075 2.98682 4.65758 0.25 8.03362 0.25V1.75ZM12.6465 6.36286C12.6465 3.81525 10.5812 1.75 8.03362 1.75V0.25C11.4097 0.25 14.1465 2.98682 14.1465 6.36286H12.6465ZM8.03362 10.9757C10.5812 10.9757 12.6465 8.91048 12.6465 6.36286H14.1465C14.1465 9.73891 11.4097 12.4757 8.03362 12.4757V10.9757ZM6.19436 10.5947C6.75688 10.8396 7.37836 10.9757 8.03362 10.9757V12.4757C7.1685 12.4757 6.3435 12.2956 5.59564 11.97L6.19436 10.5947ZM6.10104 12.0035L2.2064 13.1162L1.79431 11.674L5.68896 10.5612L6.10104 12.0035ZM1.32953 12.0597L2.87619 8.96637L4.21783 9.63719L2.67118 12.7305L1.32953 12.0597Z" fill="currentColor"/>
            <circle cx="17.6696" cy="19.5197" r="1.42451" fill="currentColor"/>
            <circle cx="21.9431" cy="19.5197" r="1.42451" fill="currentColor"/>
            <circle cx="26.2175" cy="19.5197" r="1.42451" fill="currentColor"/>
          </svg>
          <div class="menu-list__item-title">Чат</div>
          <transition name="fade">
            <div class="menu-list__link__counter" v-if="dialogCounter">
              {{ dialogCounter }}
            </div>
          </transition>
        </div>
      </li>
      <li class="menu-list__item">
        <router-link to="/feed" class="menu-list__link">
          <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.75" y="0.75" width="28.5" height="22.5" stroke="currentColor" stroke-width="1.5"/>
            <rect x="5.55078" y="6.74951" width="5.7" height="5.7" rx="2.85" stroke="currentColor" stroke-width="1.5"/>
            <path d="M14.4004 7.19922H24.0004" stroke="currentColor" stroke-width="1.5"/>
            <path d="M14.4004 11.9985H24.0004" stroke="currentColor" stroke-width="1.5"/>
            <path d="M6 16.7993H24" stroke="currentColor" stroke-width="1.5"/>
          </svg>
          <div class="menu-list__item-title">Лента</div>
          <!--<div class="menu-list__link__counter">4</div>-->
        </router-link>
      </li>
      <li class="menu-list__item" v-if="roleAccessTasks">
        <router-link :to="`/task/list/${currentUser.id}`" class="menu-list__link">
          <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 10H18" stroke="currentColor" stroke-width="1.5"/>
            <path d="M10 15H18" stroke="currentColor" stroke-width="1.5"/>
            <path d="M0.75 0.75H17.1893L23.25 6.81066V11.5V22.25H0.75V0.75Z" stroke="currentColor" stroke-width="1.5"/>
            <path d="M5 8.8L6.2 10L8 8" stroke="currentColor" stroke-width="1.5"/>
            <path d="M5 14.8L6.2 16L8 14" stroke="currentColor" stroke-width="1.5"/>
          </svg>
          <div class="menu-list__item-title">Задачи</div>
          <!--<div class="menu-list__link__counter">2</div>-->
        </router-link>
      </li>
      <li class="menu-list__item">
        <router-link :to="{name: 'UserDetail_calendarTab', params: { id: currentUser.id }}" class="menu-list__link">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.75" y="2.75" width="18.5" height="16.5" stroke="currentColor" stroke-width="1.5"/>
            <path d="M0 9H20" stroke="currentColor" stroke-width="1.5"/>
            <path d="M0 14H20" stroke="currentColor" stroke-width="1.5"/>
            <path d="M5.55469 0L5.55469 5" stroke="currentColor" stroke-width="1.5"/>
            <path d="M14.4453 0L14.4453 5" stroke="currentColor" stroke-width="1.5"/>
            <path d="M6.66602 9L6.66601 19" stroke="currentColor" stroke-width="1.5"/>
            <path d="M13.334 9L13.334 19" stroke="currentColor" stroke-width="1.5"/>
          </svg>
          <div class="menu-list__item-title">Календарь</div>
          <!--<div class="menu-list__link__counter">4</div>-->
        </router-link>
      </li>
    </ul>
</template>

<script>
export default {
  name: 'AppAsideMenuList',
  components: {},
  data () {
    return {}
  },
  props: {
    dialogWidgetActive: {
      type: Boolean,
      default: false
    },
    dialogCounter: {
      type: Number,
      default: 0
    },
    notificationWidgetActive: {
      type: Boolean,
      default: false
    },
    notificationCounter: {
      type: Number,
      default: 0
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessTasks () {
      return this.$store.getters.getRoleRightsTasks.access
    },
    roleAccessDialogs () {
      return this.$store.getters.getRoleRightsDialogs.access
    }
  },
  methods: {
    toggleNotificationWidget () {
      this.$emit('toggle-notification-widget')
    },
    toggleDialogWidget () {
      this.$emit('toggle-dialog-widget')
    }
  },
  mounted () {}
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.menu-list {
  display: flex;
  flex-direction: column;

  @media screen and (max-width: $tablet_start){
    flex-direction: row;
    height: 100%;
  }

  &__item {
    margin-bottom: 3px;

    @media screen and (max-width: $tablet_start){
      margin-bottom: 0;
      margin-right: 3px;

      &:last-child {
        margin-right: 0;
      }
    }

    &-title {
      font-weight: 100;
      margin-top: 4px;
      font-size: 11px;

      @media screen and (max-width: $tablet_start) {
        display: none;
      }
    }
  }

  &__link,
  &__button {
    position: relative;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    height: 60px;
    background: $color_second;
    color: $color-main;
    cursor: pointer;
    user-select: none;

    @media screen and (max-width: $tablet_start){
      height: 100%;
      padding: 6px;
      width: 40px;
      border-radius: 3px;
      background: #133568;

      svg {
        height: 100%;
        width: 100%;
      }
    }

    &__counter {
      position: absolute;
      height: 13px;
      min-width: 13px;
      border-radius: 7px;
      padding: 4px;
      top: auto;
      right: 14px;
      bottom: 12px;
      left: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 9px;
      background: $color_fifth;
      user-select: none;
    }
  }

  &__button {
    z-index: 9999;

    &:before,
    &:after {
      position: absolute;
      content: '';
      display: none;
      left: 0;
      right: auto;
      width: 0;
      height: 0;
    }

    &:before {
      top: 0;
      border-top: 35px solid $color_main;
      border-right: 16px solid transparent;
    }

    &:after {
      bottom: 0;
      border-top: 35px solid $color_main;
      border-right: 16px solid transparent;
      transform: scale(1, -1);
    }
  }
}

// общий селектор для кнопок виджетов
.active {
  width: 86px;
  transform: translateX(-16px);
  padding-left: 16px;

  &.notification-btn {
    background: $button_color_fourth;

    &:before,
    &:after {
      border-top: 35px solid $color_sixth;
    }
  }

  &.dialog-btn {
    background: $button_color_third;
  }

  &:before,
  &:after {
    display: block;
  }

  @media screen and (max-width: $tablet_start) {
    width: 40px;
    padding-left: 6px;
    transform: translateX(0);

    &:before,
    &:after {
      display: none;
    }
  }
}

.router-link-active {
  background: #F65F59;
  background: $button_color;
}
</style>
